import { Box, Heading, Stack, useColorModeValue } from '@chakra-ui/react';
import { IoPeopleSharp } from 'react-icons/io5';
import { TbReportAnalytics } from 'react-icons/tb';
import CardManager from 'shared/components/CardManager';
import CreateResellerCustomerModal from './components/CreateResellerCustomerModal';
import ResellerReport from './components/ResellerReport/ResellerReport';
import ResellerSearchBar from './components/ResellerSearchBar';
import ResellerTable from './components/ResellerTable';
import { useResellerContext } from './ResellerContext';

const ResellerHome = () => {
  const { createModalOpen, setCreateModalOpen } = useResellerContext();
  const bgColor = useColorModeValue('white', 'gray.800');

  return (
    <Stack
      minH="100vh"
      minW={{ lg: '740px' }}
      w={{ base: '90%', lg: '85%' }}
      m="auto"
      px={{ base: '1rem', lg: '4rem' }}
      pt={{ base: '1rem', lg: '1.5rem' }}
      pb={{ base: '2rem', lg: '4rem' }}
      gap="1.5rem"
    >
      <Heading size="lg" color="gray.600">
        Clientes
      </Heading>
      <CardManager
        allTab={false}
        tabs={[
          { label: 'Clientes', icon: IoPeopleSharp },
          { label: 'Relatórios', icon: TbReportAnalytics },
        ]}
      >
        <Box bg={bgColor} borderRadius="lg" shadow="sm" p="1.5rem">
          <Stack gap="1.5rem">
            <ResellerSearchBar />
            <ResellerTable />
          </Stack>
        </Box>
        <ResellerReport />
      </CardManager>
      <CreateResellerCustomerModal
        isOpen={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
      />
    </Stack>
  );
};

export default ResellerHome;
